/**
 * Normalize a node title without removing explicit line breaks.
 *
 * Mind-map labels do not use repeated horizontal whitespace as layout data.
 * Collapsing it avoids indentation being carried to a wrapped line while
 * retaining the line breaks intentionally entered by the user.
 *
 * @param {unknown} topic
 * @returns {string}
 */
export function normalizeNodeTopicWhitespace(topic) {
    if (typeof topic !== 'string') {
        return '';
    }

    return topic
        .split(/\r\n?|\n/)
        .map(line => line.replace(/[\t \f\v\u00a0]+/g, ' ').trim())
        .join('\n');
}
